import {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {getAccounts} from '../../../../../redux/suggestions/suggestionsActions';
import {XHR_LOADING_STATE} from '../../../../../assets/constants/constants';
import isScrollEnd from '../../../../../functions/isScrollEnd';

export default function useAccountsScroll(isOpen: boolean, search: string) {
    const accounts = useSelector((s: any) => s.suggestions.accounts) || [];
    const xhr = useSelector((s: any) => s.suggestions.getAccountsXHR);
    const [hasMore, setHasMore] = useState(true);
    const popupRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = popupRef.current;
        if(!isOpen || !el) return;
        const onScroll = (e) => {
            if(!isScrollEnd(e) || !hasMore || xhr === XHR_LOADING_STATE) return;
            getAccounts({search, limit: 20, offset: accounts.length})
                .then((res) => setHasMore(res?.packages?.length === 20));
        };
        el.addEventListener('scroll', onScroll, true);
        return () => el.removeEventListener('scroll', onScroll, true);
    }, [isOpen, accounts.length, search, xhr, hasMore]);

    return {popupRef, resetPagination: () => setHasMore(true)};
}
